export default __webpack_public_path__ + "static/media/171.c5b854d9.jpg";